import React from 'react';
import { Form } from 'react-bootstrap';
import styles from './styles.module.scss';

interface EventTypeFilterProps {
  selectedTypes: string[];
  onChange: (types: string[]) => void;
}

const EVENT_TYPES = [
  { value: 'renewal_notice', label: 'Renewal Notice' },
  { value: 'lease_expiration', label: 'Lease Expiration' },
  { value: 'rent_commencement', label: 'Rent Commencement' },
  { value: 'option_notice', label: 'Option Notice' },
  { value: 'rent_increase', label: 'Rent Increase' },
  { value: 'inspection', label: 'Inspection' },
  { value: 'insurance_expiration', label: 'Insurance Expiration' },
  { value: 'other', label: 'Other' },
];

export const EventTypeFilter: React.FC<EventTypeFilterProps> = ({ selectedTypes, onChange }) => {
  const handleToggle = (eventType: string) => {
    if (selectedTypes.includes(eventType)) {
      onChange(selectedTypes.filter(t => t !== eventType));
    } else {
      onChange([...selectedTypes, eventType]);
    }
  };

  return (
    <div className={styles.filterSection}>
      {EVENT_TYPES.map(({ value, label }) => (
        <Form.Check
          key={value}
          type="checkbox"
          id={`event-type-${value}`}
          label={label}
          checked={selectedTypes.includes(value)}
          onChange={() => handleToggle(value)}
          className={styles.filterCheckbox}
        />
      ))}
    </div>
  );
};